import store from '../store/Store';
import { ICard } from '../interface/ICardList';
import { IConfig } from '../interface/IConfig';
import { addClass, makeElement, leadingZeros } from '../libs/Utils';
import CardDataStore from '../store/CardDataStore';
export default class CardList {

    private cardCon: Element | null = document.querySelector('.history-list');
    private newList: string[] | undefined;

    constructor() {
        store.CardDataStore.updateEvents.on( this.update.bind(this) );
    }

    public clearList(){
        if (this.cardCon) {
            this.cardCon.innerHTML = '';
        }
    }
    
    private update(_src: CardDataStore, _data: ICard[]){
        this.newList = _data.map( item => this.templ(item, store.CommonDataStore.config));
        this.animate();
    }
    
    private animate(){
        const cardItem = this.newList?.shift();
        if (cardItem) {
            const el = makeElement(cardItem);
            this.cardCon?.appendChild( el );
            
            setTimeout(() => addClass( el, 'ani'), 15 );
            setTimeout(() => this.animate(), 70);
        }
    }

    private templ(_d: ICard, _config: IConfig) {
        const da = new Date(_d.updateDate);
        const isNew = (((+new Date()) - (+da))/1000/3600/24 < 7);

        return `
        <li class="history-article">
            <a ${_config.device === 'launcher'? ' target="_blank"': ''} href="${_config.urlPrefix?_config.urlPrefix:''}${_d.link}" class="outlink">
                <div class="history-thumb">
                    <img src="${_d.thumbnail}" class="thumb" />
                    ${(_config.useLabel && _d.optionalCategoryId)? `
                    <span class="history-thumb-tag history-thumb-tag-${_d.optionalCategoryId.toLowerCase()}">${_d.optionalCategoryName}</span>
                    `: ``}
                </div>
                <div class="words">
                    <div class="history-subject">
                        ${isNew?'<span class="history-subject-icon">new</span>':''}
                        <h3 class="history-subject-title">${_d.title}</h3>
                    </div>
                    <p class="history-summary">${_d.summary}</p>
                    <div class="history-date">${da.getFullYear()}-${leadingZeros(da.getMonth() + 1, 2)}-${leadingZeros(da.getDate(), 2)}</div>
                </div>
            </span>
        </li>`;
    }


} // end of class